<script>
import { cloneDeep } from 'lodash'
import { APP_CHANNEL } from '@/common/utils/variables';
import { SHARE_ACTION_OPTIONS, NUOYA_SHARE_ACTION_OPTIONS, GAOKE_ACTION_OPTIONS } from '../../constant'
export default {
  props: {
    currentImage: {
      type: Object,
      default: () => ({})
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      SHARE_ACTION_OPTIONS
    }
  },
  computed: {
    shareActionOptions() {
      const { appPlatform, currentImage } = this
      const key = currentImage.key
      if (APP_CHANNEL === 'NUOYA') {
        if (key === 'interestTable') {
          return NUOYA_SHARE_ACTION_OPTIONS.filter(e => !['print'].includes(e.key))
        }
        return NUOYA_SHARE_ACTION_OPTIONS.filter(e => !['setting'].includes(e.key))
      }
      if (['WECHAT_GAOKE', 'WXMP', 'WXMP_BXZ'].includes(appPlatform)) {
        return GAOKE_ACTION_OPTIONS
      }

      let actionOptions = cloneDeep(SHARE_ACTION_OPTIONS)
      if (key === 'interestTable') {
        actionOptions = actionOptions.filter(e => !['print'].includes(e.key))
      } else {
        actionOptions = actionOptions.filter(e => !['theme', 'setting'].includes(e.key))
      }
      if (['H5_BXZ'].includes(APP_CHANNEL)) {
        actionOptions = actionOptions.filter(e => !['wechat_timeline', 'wechat_friends', 'qq_friends', 'print'].includes(e.key))
      }
      return actionOptions
    }
  },
  methods: {
    handleShare(option = {}) {
      this.$emit('handle', option.key)
    },
  },
}
</script>
<template>
  <div class="export_images_actions" :class="{ 'center': shareActionOptions.length <= 4 }">
    <figure
      v-for="option in shareActionOptions"
      :key="option.key"
      @click="handleShare(option)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 90 90"
        version="1.1"
        v-html="option.svgData"
      />
      <figcaption>{{ option.name }}</figcaption>
    </figure>
  </div>
</template>
<style lang="postcss" scoped>
.export_images_actions {
  display: inline-block;
  text-align: left;
  white-space: nowrap;
  & figure {
    display: inline-block;
    text-align: center;
    & svg {
      width: 50px;
      height: 50px;
      margin-bottom: 4px;
    }
  }
  & figure:not(:last-child) {
    margin-right: 30px;
  }
}
.export_images_actions.center {
  text-align: center;
}
</style>